import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class OtherSportsHomePage extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="other"
      title="Other Sports News"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/OtherSports/containers/OtherSportsHomePage.js